module.exports = __webpack_public_path__ + "img/example.108af6d9.png";